import { Link } from "react-router-dom";
import { SubNavbar } from "./SubNavbar";
import { useNavbarLogic } from "./navbar/useNavbarLogic";
import { DesktopNav } from "./navbar/DesktopNav";
import { MobileNav } from "./navbar/MobileNav";
import { ErrorBoundary } from "./ErrorBoundary";
import { Logo } from "./Logo";

export const Navbar = () => {
  const {
    user,
    isAdmin,
    showArtistContent,
    showBuyerContent,
    handleSignOut,
    mobileMenuOpen,
    setMobileMenuOpen,
    cartOpen,
    setCartOpen,
  } = useNavbarLogic();

  return (
    <ErrorBoundary>
      <nav className="sticky top-0 z-50 w-full bg-[hsl(var(--glass-bg))] backdrop-blur-2xl border-b border-[hsl(var(--glass-border-strong))] shadow-[0_4px_16px_hsl(var(--glass-shadow)),inset_0_-1px_0_hsl(var(--glass-highlight))]">
        <div className="container flex h-16 items-center justify-between">
          <div className="flex items-center">
            <Link to={user ? "/home" : "/"}>
              <Logo size="sm" />
            </Link>
          </div>

          <DesktopNav
            user={user}
            showArtistContent={showArtistContent}
            showBuyerContent={showBuyerContent}
            isAdmin={isAdmin}
            cartOpen={cartOpen}
            onCartOpenChange={setCartOpen}
            handleSignOut={handleSignOut}
          />

          <MobileNav
            user={user}
            showArtistContent={showArtistContent}
            showBuyerContent={showBuyerContent}
            isAdmin={isAdmin}
            mobileMenuOpen={mobileMenuOpen}
            onMobileMenuOpenChange={setMobileMenuOpen}
            cartOpen={cartOpen}
            onCartOpenChange={setCartOpen}
            handleSignOut={handleSignOut}
          />
        </div>
      </nav>
      <SubNavbar />
    </ErrorBoundary>
  );
};
